import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ShieldCheck, ShieldAlert, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function VerifyMember() {
  const { code } = useParams();
  const [state, setState] = useState({ loading: true });
  useEffect(() => {
    api.get(`/public/verify/member/${encodeURIComponent(code)}`)
      .then((r) => setState({ data: r.data }))
      .catch(() => setState({ error: true }));
  }, [code]);

  const ok = state.data?.active;
  return (
    <section className="max-w-xl mx-auto px-6 py-20" data-testid="verify-member-page">
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#B38728] font-mono">Membership Verification</p>
      <h1 className="font-display text-4xl sm:text-5xl font-semibold text-[#194324] mt-2">Hatha Vidya Charitable Trust</h1>
      <div className="mt-8 rounded-2xl border border-[#E2DAD0] bg-white p-8" data-testid="verify-member-result">
        {state.loading ? (
          <Loader2 className="h-6 w-6 animate-spin text-[#C59B27]" />
        ) : state.error ? (
          <div className="flex gap-3 items-start text-[#D9531E]"><ShieldAlert className="h-7 w-7 shrink-0" /><div><p className="font-semibold">Not verified</p><p className="text-sm text-[#5C7264] mt-1">This QR code does not match any member record.</p></div></div>
        ) : (
          <div className="flex gap-3 items-start">
            {ok ? <ShieldCheck className="h-8 w-8 text-[#2D623A] shrink-0" /> : <ShieldAlert className="h-8 w-8 text-[#D9531E] shrink-0" />}
            <div>
              <p className={`font-semibold ${ok ? "text-[#194324]" : "text-[#D9531E]"}`} data-testid="verify-member-status">{ok ? "Verified active member" : `Membership not active (${state.data.status})`}</p>
              <p className="font-display text-2xl text-[#194324] mt-3" data-testid="verify-member-name">{state.data.full_name}</p>
              <p className="text-sm text-[#5C7264] mt-1 font-mono" data-testid="verify-member-id">{state.data.member_id} · {state.data.membership_type}</p>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
